import React from 'react';
import { Handle, Position } from '@xyflow/react';

const NODE_SIZE = { width: 220, height: 120 };

function ManagedDiskNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 p-3 transition-colors ${
        selected
          ? 'border-amber-500 bg-amber-50/70 dark:bg-amber-900/30'
          : 'border-amber-300 bg-amber-50/40 dark:bg-amber-900/20'
      }`}
      style={NODE_SIZE}
    >
      <Handle type="target" position={Position.Top} className="!bg-amber-500" />
      <div className="mb-1 flex items-center gap-2">
        <svg
          className="h-4 w-4 text-amber-600 dark:text-amber-400 shrink-0"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <ellipse cx="12" cy="5" rx="9" ry="3" />
          <path d="M3 5v14a9 3 0 0 0 18 0V5" />
          <path d="M3 12a9 3 0 0 0 18 0" />
        </svg>
        <span className="text-sm font-semibold text-amber-900 dark:text-amber-100 truncate">
          {data.name}
        </span>
      </div>
      {data.diskType && (
        <span className="inline-block bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.diskType}
        </span>
      )}
      {data.diskSize && (
        <span className="ml-1 inline-block bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200 text-xs font-mono px-2 py-0.5 rounded">
          {data.diskSize} GB
        </span>
      )}
      <div className="mt-1 text-xs text-gray-500 dark:text-gray-400">Managed Disk</div>
      <Handle type="source" position={Position.Bottom} className="!bg-amber-500" />
    </div>
  );
}

export default ManagedDiskNode;
